import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  connectToTrainerDesktop,
  useSelectIsTrainerDesktopStartPending,
  useSelectIsTrainerDesktopStopPending
} from 'Courses/data';
import { useAppDispatch } from 'Store';
import { openExternalUrl } from 'Utils/redirects';

import { ConnectToDesktopButton } from './ConnectToDesktopBase';

type Props = {
  courseId: string;
  disabled?: boolean;
  isHighlighted: boolean;
  isMinimized: boolean;
};

export const ConnectToTrainerDesktopButton = ({
  courseId,
  disabled,
  isHighlighted,
  isMinimized
}: Readonly<Props>) => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const isTrainerDesktopStartPending = useSelectIsTrainerDesktopStartPending(courseId);
  const isTrainerDesktopStopPending = useSelectIsTrainerDesktopStopPending(courseId);
  const redirectToDesktop = (desktopLink: string) => openExternalUrl(desktopLink);

  const shouldNotRedirectToNewTab = true;

  const connectToDesktop = () =>
    dispatch(connectToTrainerDesktop(courseId)).then(response => {
      const newLink = (response?.payload as any)?.trainerDesktop?.link;

      if (!shouldNotRedirectToNewTab && newLink) {
        redirectToDesktop(newLink as string);
      }
    });

  return (
    <ConnectToDesktopButton
      buttonText={t('Connect')}
      onConnectToDesktopClick={connectToDesktop}
      disabled={disabled}
      isDesktopStartPending={isTrainerDesktopStartPending}
      isDesktopStopPending={isTrainerDesktopStopPending}
      isDesktopDeletePending={false}
      isHighlighted={isHighlighted}
      isMinimized={isMinimized}
    />
  );
};
